import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core'
import { BsModalService } from 'ngx-bootstrap/modal'
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { DatePipe } from '@angular/common'
@Component({
  selector: 'app-board-structure',
  templateUrl: './board-structure.component.html',
  styleUrls: ['./board-structure.component.scss']
})
export class BoardStructureComponent implements OnInit {
  noOfIndependentDirector: any
  noOfAuditCommittee: any
  bodStructures = []
  negativeNetProfitTooltip =
    'เคยเป็นกรรมการในบจ.ที่ภายใน 5 ปีมีปีใดปีหนึ่งที่บจ.นั้นขาดทุน'
  badAuditorOpinionTooltip =
    'เคยเป็นกรรมการในบจ.ที่ผู้สอบไม่แสดงความเห็นในงบหรือแสดงความเห็นแบบมีเงื่อนไข'
  bodList
  lastName
  firstName
  asc = 1
  desc = -1
  boardId
  secSymbol
  isAE
  noOfBod
  @ViewChild('template') template: TemplateRef<any>
  modalRef: BsModalRef
  subscription: Subscription
  constructor(
    private modalService: BsModalService,
    private store: StoreService,
    private cpmService: CpmService,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.isAE = response['ae']
        this.secSymbol = response['securitySymbol']
        this.setBoardStructure(response['securitySymbol'])
      })
  }
  async setBoardStructure(symbol) {
    await this.cpmService.getBODList(symbol).then(bods => {
      this.bodList = bods
      this.noOfBod = bods.noOfBod
      this.noOfAuditCommittee = bods.noOfAuditCommittee
      this.noOfIndependentDirector = bods.noOfIndependentDirector
    })

    const bodLists = await this.setDataBod(this.bodList.bod)
    this.bodStructures = []
    bodLists.map(bodStructures => {
      const bodStructure = {}
      const snStartdate = []
      const positionStartdate = []
      bodStructure['titleThi'] = bodStructures.titleThi
      bodStructure['firstNameThi'] = bodStructures.firstNameThi
      bodStructure['lastNameThi'] = bodStructures.lastNameThi
      bodStructure['boardId'] = bodStructures.boardId
      bodStructure['negativeNetProfit'] = bodStructures.negativeNetProfit
      bodStructure['badAuditorOpinion'] = bodStructures.badAuditorOpinion

      let prevStartDate
      bodStructures.startDate.map(startDate => {
        const dateFormat = this.datePipe.transform(startDate, 'd MMM yyyy')
        snStartdate.push(dateFormat);
        if (prevStartDate) {
          if (prevStartDate !== startDate) {
            positionStartdate.push(
              dateFormat
            )
          }
        } else {
          prevStartDate = startDate
          positionStartdate.push(
            dateFormat
          )
        }
      })

      if (positionStartdate.length !== 1) {

        bodStructure['startDate'] = snStartdate.toString().split(',').join(', ')
      } else {

        bodStructure['startDate'] = positionStartdate.join(', ')
      }

      bodStructure['positionNameEng'] = bodStructures.positionNameEng.join(', ')
      this.bodStructures.push(bodStructure)
    })

  }

  setDataBod(bodlist) {
    const bods = bodlist.reduce((acc, bod) => {
      const found = acc.find(x => {
        return x.boardId === bod.boardId
      })
      if (found) {
        found.positionNameThi.push(bod.positionNameThi)
        found.positionNameEng.push(bod.positionNameEng)
        found.startDate.push(bod.startDate)
      } else {
        const x = Object.assign({}, bod)
        x.positionNameThi = [bod.positionNameThi]
        x.positionNameEng = [bod.positionNameEng]
        x.startDate = [bod.startDate]
        acc.push(x)
      }
      return acc
    }, [])
    return bods
  }

  onClickOpenModal(boardId, firstName, lastName) {
    this.lastName = lastName
    this.firstName = firstName
    this.boardId = boardId
    this.openModal(this.template)
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg' })
    )
  }
  closeModal() {
    this.modalRef.hide()
  }

  groupBy(objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
      const key = obj[property]
      if (!acc[key]) {
        acc[key] = []
      }
      acc[key].push(obj)
      return acc
    }, {})
  }

  isNegativeNetProfit(bod) {
    return bod.negativeNetProfit ? 'Yes' : 'No'
  }

  isBadAuditorOpinion(bod) {
    return bod.badAuditorOpinion ? 'Yes' : 'No'
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/board-structure/board-structure.component.ts